import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-470b7918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bookCapsule__head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bookCapsule__head_title" }, "きょうの1さつ", -1))
const _hoisted_3 = { class: "bookCapsule__head_buttonArea" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bookCapsule__skip" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bookCapsule__skip_text" }, "スキップする")
], -1))
const _hoisted_5 = { class: "bookCapsule__contents" }
const _hoisted_6 = { class: "stage" }
const _hoisted_7 = {
  key: 0,
  class: "stage__error"
}
const _hoisted_8 = {
  key: 0,
  class: "stage__error_point"
}
const _hoisted_9 = { class: "stage__point" }
const _hoisted_10 = { class: "stage__point_inner" }
const _hoisted_11 = { class: "stage__point_consumption" }
const _hoisted_12 = { class: "stage__point_consumption_inner" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("使")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "つか", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("うポイント")
const _hoisted_18 = { class: "stage__point_consumption_text" }
const _hoisted_19 = { class: "stage__point_num" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("P ")
const _hoisted_21 = { class: "stage__point_calc" }
const _hoisted_22 = { class: "stage__point_calc_inner" }
const _hoisted_23 = { class: "stage__point_remaining" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" のこりのポイント")
const _hoisted_25 = { class: "stage__point_num" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("P ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stage__point_calc_arrow" }, "→", -1))
const _hoisted_28 = { class: "stage__point_color" }
const _hoisted_29 = { class: "stage__point_num" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("P")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stage__point_text" }, "たりません", -1))
const _hoisted_32 = {
  key: 1,
  class: "stage__error_limit"
}
const _hoisted_33 = { class: "stage__point stage__error_limit_inner" }
const _hoisted_34 = { class: "stage__point_inner" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("回")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "まわ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("せるのは1")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("日")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "にち", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode("10")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("回")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "かい", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode("です")
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" また")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("明日")
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "あした", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode("回")
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "まわ", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_60 = /*#__PURE__*/_createTextVNode("してください ")
const _hoisted_61 = { class: "stage__error_img" }
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 0,
  class: "stage__scene_start"
}
const _hoisted_64 = {
  key: 0,
  class: "stage__point"
}
const _hoisted_65 = {
  key: 0,
  class: "stage__point_inner"
}
const _hoisted_66 = { class: "stage__point_consumption" }
const _hoisted_67 = { class: "stage__point_consumption_inner" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("使")
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "つか", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode("うポイント")
const _hoisted_73 = { class: "stage__point_consumption_text" }
const _hoisted_74 = { class: "stage__point_num" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("P ")
const _hoisted_76 = { class: "stage__point_calc" }
const _hoisted_77 = { class: "stage__point_calc_inner" }
const _hoisted_78 = { class: "stage__point_remaining" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" のこりのポイント")
const _hoisted_80 = { class: "stage__point_num" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("P ")
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stage__point_calc_arrow" }, "→", -1))
const _hoisted_83 = { class: "stage__point_color" }
const _hoisted_84 = { class: "stage__point_num" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("P ")
const _hoisted_86 = { class: "stage__playButton" }
const _hoisted_87 = { class: "stage__playButton_text" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode("回")
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "まわ", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_92 = /*#__PURE__*/_createTextVNode("す")
const _hoisted_93 = {
  key: 2,
  class: "stage__scene_result"
}
const _hoisted_94 = {
  key: 0,
  class: "result"
}
const _hoisted_95 = { class: "result__inner" }
const _hoisted_96 = { class: "result__book" }
const _hoisted_97 = { class: "result__body" }
const _hoisted_98 = { class: "result__book_title" }
const _hoisted_99 = { class: "result__buttonArea" }
const _hoisted_100 = { class: "result__button" }
const _hoisted_101 = { class: "result__button_icon" }
const _hoisted_102 = ["src"]
const _hoisted_103 = { class: "result__button_text" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode("本の")
const _hoisted_105 = /*#__PURE__*/_createTextVNode("情報")
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "じょうほう", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_109 = { class: "result__button" }
const _hoisted_110 = { class: "result__button_icon" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result__button_text--add" }, "本だなにいれる", -1))
const _hoisted_112 = { class: "result__button" }
const _hoisted_113 = { class: "result__button_icon" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result__button_text--add" }, "本だなにいれる", -1))
const _hoisted_115 = { class: "result__animation" }
const _hoisted_116 = { class: "result__animation_star" }
const _hoisted_117 = ["srcset"]
const _hoisted_118 = ["srcset"]
const _hoisted_119 = ["src"]
const _hoisted_120 = { class: "result__animation_ball result__animation_ball--left" }
const _hoisted_121 = ["srcset"]
const _hoisted_122 = ["srcset"]
const _hoisted_123 = ["src"]
const _hoisted_124 = { class: "result__animation_ball result__animation_ball--right" }
const _hoisted_125 = ["srcset"]
const _hoisted_126 = ["srcset"]
const _hoisted_127 = ["src"]
const _hoisted_128 = {
  key: 0,
  class: "dialogArea"
}

import { inject, ref, computed, Ref } from 'vue'

import { injectionKeys } from '@/constants/injectionKeys'
import { useLoadingStore } from '@/store/loading'
import { useSnackbarStore } from '@/store/snackbar'

import { GetExecGachaResponse, CheckExecGachaResponse } from '@/models/ApiIF'

import { useHandleError } from '@/composables/useHandleError'

import AppButton from '@/components/AppButton/AppButton.vue'
import AppTooltip from '@/components/AppTooltip/AppTooltip.vue'
import AppImage from '@/components/AppImage/AppImage.vue'
import Book from '@/components/Book/Book.vue'
import SlotModal from '@/components/SlotModal/SlotModal.vue'
import SlotDialog from '../SlotDialog/SlotDialog.vue'
import GachaAnimation from '@/components/GachaAnimation/GachaAnimation.vue'
import ApiHelper from '@/helpers/ApiHelper'
import StoreHelper from '@/helpers/StoreHelper'
import { GA_EVENT_VALUES, GA_EVENT_DIMENSIONS } from '@/constants/ga'
import GaHelper from '@/helpers/GaHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookCapsule',
  emits: ['close'],
  setup(__props, { emit }) {

/**
 * BookCapsule.
 *
 * 今日の１さつ.
 */

const loadingStore = useLoadingStore()
const { handleErrors } = useHandleError()

// ID認証、同時接続ID、IP認証
const isUserId = inject<Ref<boolean>>(injectionKeys.isUserId)!
const isSharedId = inject<Ref<boolean>>(injectionKeys.isSharedId)!
const isFixedIp = inject<Ref<boolean>>(injectionKeys.isFixedIp)!
const isSharedIdOrFixedIp = computed(() => {
  return isSharedId.value || isFixedIp.value
})

// モーダルとじる

const close = () => {
  emit('close')
}

// 本だなにいれる
const snackbarStore = useSnackbarStore()
snackbarStore.setSnackbarPosition(true)
snackbarStore.$subscribe(async (mutation, state) => {
  if (state.errorMessages.length) {
    errorMessages.value = state.errorMessages
  }
})

// 本だなにいれる非活性&ツールチップ
const bookCapsule = ref<GetExecGachaResponse | null>(null)
const bookShelfEntryErrorMessage = computed(() => {
  if (bookCapsule.value?.bookShelfEntryFlg !== 0) {
    return 'すでに本だなにはいっています'
  }
  return ''
})

// エラーダイアログ
const errorMessages = ref<string[]>([])
const onCloseErrorDialog = () => {
  errorMessages.value = []
  snackbarStore.errorMessages = []
}

// ガチャデータ
// 同時接続ID・固定IPの場合はresultが常にtrue
const gachaStatus = ref<CheckExecGachaResponse | null>(null)
// ガチャ可否確認
const isGachaPlay = computed(() => gachaStatus.value?.result)
// ポイント残高確認
const isGachaPointEnough = computed(() => {
  if (
    gachaStatus.value &&
    gachaStatus.value.remainingPoints >= gachaStatus.value.consumptionPoints
  ) {
    // ポイント不足
    return true
  } else {
    return false
  }
})

// ガチャアニメーション
const scene = ref<number>(0)
const animeScene = ref<number>(0)
const animationTime = 8200
// 現在のシーンナンバー
const indexPlayAnimation = computed(() => scene.value)

// ガチャ開始
const playAnimation = () => {
  scene.value = 1

  setTimeout(() => {
    animeScene.value = 1
  }, 4000)

  setTimeout(() => {
    animeScene.value = 2
  }, 4600)

  setTimeout(() => {
    scene.value = 2
  }, animationTime)
}
// 結果までスキップ
const onSkipAnimation = () => {
  scene.value = 2
}
// まわす
const onClickPlay = async () => {
  playAnimation()
  execGacha()
}

// ↓ 主にTF様の編集領域
// ------------------------------

/**
 * ガチャ使用可否チェック
 */
const checkExecGacha = async () => {
  await ApiHelper.checkExecGacha({})
    .then((res) => {
      gachaStatus.value = res
    })
    .catch((err) => {
      handleErrors(err)
    })
}

/**
 * ガチャ結果取得
 */
const execGacha = async () => {
  await ApiHelper.getExecGacha({})
    .then((res) => {
      bookCapsule.value = res
      StoreHelper.updatePoint(res.afterPoints)
      GaHelper.registerGaEvent(GA_EVENT_VALUES.bookCapsule.execGacha, [
        res.contentsId,
      ])
    })
    .catch((err) => {
      handleErrors(err)
    })
}

/**
 * 初期表示用のリクエスト
 */
const initialRequest = async () => {
  // ID認証ユーザーの場合、ガチャ使用可否チェック
  if (isUserId.value) {
    const callCheckExecGacha = checkExecGacha()
    await callCheckExecGacha
  } else {
    gachaStatus.value = {
      result: true,
      consumptionPoints: 0,
      remainingPoints: 0,
      remainingGachaNum: 0,
    }
  }
}

const init = (async () => {
  try {
    // ローディング開始
    loadingStore.setLoading(true, 'modal')

    // 初期表示用のリクエスト
    const callInitialRequest = initialRequest()
    await callInitialRequest
  } catch (err) {
    handleErrors(err)
  } finally {
    // ローディング終了
    loadingStore.setLoading(false, 'modal')
  }
})()

return (_ctx: any,_cache: any) => {
  const _component_rb = _resolveComponent("rb")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SlotModal, {
      icon: require('@/assets/image/icon/icon_book_capsule.svg'),
      button: _unref(indexPlayAnimation) !== 1,
      fit: true,
      keyboard: false,
      onClose: close
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_unref(isGachaPlay) && scene.value === 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "animationLink",
                  onClick: onSkipAnimation
                }, [
                  _createVNode(AppButton, {
                    tag: "span",
                    rounded: "pill",
                    color: "negative"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (!_unref(isGachaPlay) && gachaStatus.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (!_unref(isGachaPointEnough) && gachaStatus.value.remainingGachaNum > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, [
                                _createElementVNode("ruby", null, [
                                  _createVNode(_component_rb, null, {
                                    default: _withCtx(() => [
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_14,
                                  _hoisted_15,
                                  _hoisted_16
                                ]),
                                _hoisted_17,
                                _createElementVNode("span", _hoisted_18, [
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(gachaStatus.value.consumptionPoints), 1),
                                  _hoisted_20
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("p", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, [
                                  _hoisted_24,
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(gachaStatus.value.remainingPoints), 1),
                                  _hoisted_26
                                ]),
                                _hoisted_27,
                                _createElementVNode("span", _hoisted_28, [
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(gachaStatus.value.consumptionPoints -
                          gachaStatus.value.remainingPoints), 1),
                                  _hoisted_30,
                                  _hoisted_31
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createVNode(GachaAnimation, {
                          start: false,
                          scene: animeScene.value
                        }, null, 8, ["scene"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("p", null, [
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_35
                                  ]),
                                  _: 1
                                }),
                                _hoisted_36,
                                _hoisted_37,
                                _hoisted_38
                              ]),
                              _hoisted_39,
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_40
                                  ]),
                                  _: 1
                                }),
                                _hoisted_41,
                                _hoisted_42,
                                _hoisted_43
                              ]),
                              _hoisted_44,
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_45
                                  ]),
                                  _: 1
                                }),
                                _hoisted_46,
                                _hoisted_47,
                                _hoisted_48
                              ]),
                              _hoisted_49,
                              _hoisted_50,
                              _hoisted_51,
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_52
                                  ]),
                                  _: 1
                                }),
                                _hoisted_53,
                                _hoisted_54,
                                _hoisted_55
                              ]),
                              _createElementVNode("ruby", null, [
                                _createVNode(_component_rb, null, {
                                  default: _withCtx(() => [
                                    _hoisted_56
                                  ]),
                                  _: 1
                                }),
                                _hoisted_57,
                                _hoisted_58,
                                _hoisted_59
                              ]),
                              _hoisted_60
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("img", {
                            src: require('@/assets/image/gacha/img_gacha_error.svg'),
                            alt: ""
                          }, null, 8, _hoisted_62)
                        ])
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["stage__scene", `stage__scene--${scene.value}`])
                }, [
                  (scene.value === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        (gachaStatus.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              (gachaStatus.value.remainingPoints && !_unref(isSharedIdOrFixedIp))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("p", _hoisted_67, [
                                        _createElementVNode("ruby", null, [
                                          _createVNode(_component_rb, null, {
                                            default: _withCtx(() => [
                                              _hoisted_68
                                            ]),
                                            _: 1
                                          }),
                                          _hoisted_69,
                                          _hoisted_70,
                                          _hoisted_71
                                        ]),
                                        _hoisted_72,
                                        _createElementVNode("span", _hoisted_73, [
                                          _createElementVNode("span", _hoisted_74, _toDisplayString(gachaStatus.value.consumptionPoints), 1),
                                          _hoisted_75
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_76, [
                                      _createElementVNode("p", _hoisted_77, [
                                        _createElementVNode("span", _hoisted_78, [
                                          _hoisted_79,
                                          _createElementVNode("span", _hoisted_80, _toDisplayString(gachaStatus.value.remainingPoints), 1),
                                          _hoisted_81
                                        ]),
                                        _hoisted_82,
                                        _createElementVNode("span", _hoisted_83, [
                                          _createElementVNode("span", _hoisted_84, _toDisplayString(gachaStatus.value.remainingPoints -
                          gachaStatus.value.consumptionPoints), 1),
                                          _hoisted_85
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: _normalizeClass(["stage__buttonArea", { 'is-noPointShow': _unref(isSharedIdOrFixedIp) }])
                              }, [
                                _createElementVNode("button", {
                                  class: "animationLink",
                                  onClick: onClickPlay
                                }, [
                                  _createVNode(AppButton, {
                                    tag: "span",
                                    rounded: "pill",
                                    shadow: "m"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_86, [
                                        _createElementVNode("span", _hoisted_87, [
                                          _createElementVNode("ruby", null, [
                                            _createVNode(_component_rb, null, {
                                              default: _withCtx(() => [
                                                _hoisted_88
                                              ]),
                                              _: 1
                                            }),
                                            _hoisted_89,
                                            _hoisted_90,
                                            _hoisted_91
                                          ]),
                                          _hoisted_92
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ], 2)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (scene.value !== 2)
                    ? (_openBlock(), _createBlock(GachaAnimation, {
                        key: 1,
                        start: scene.value === 1,
                        scene: animeScene.value
                      }, null, 8, ["start", "scene"]))
                    : _createCommentVNode("", true),
                  (scene.value === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                        (bookCapsule.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _createVNode(Book, {
                                    contentsId: bookCapsule.value.contentsId,
                                    thumbnailPath: bookCapsule.value.thumbnailPath,
                                    bookShelfEntryFlg: bookCapsule.value.bookShelfEntryFlg,
                                    hasAction: false
                                  }, null, 8, ["contentsId", "thumbnailPath", "bookShelfEntryFlg"])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("p", _hoisted_98, _toDisplayString(bookCapsule.value.contentsName), 1),
                                  _createElementVNode("div", _hoisted_99, [
                                    _createVNode(_component_router_link, {
                                      to: {
                        name: 'BookDetail',
                        params: { bookId: bookCapsule.value.contentsId },
                      },
                                      class: "actionButton animationLink"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(AppButton, {
                                          tag: "span",
                                          rounded: "pill",
                                          shadow: "m"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_100, [
                                              _createElementVNode("span", _hoisted_101, [
                                                _createElementVNode("img", {
                                                  src: 
                                require('@/assets/image/icon/icon_book_info.svg')
                              ,
                                                  alt: ""
                                                }, null, 8, _hoisted_102)
                                              ]),
                                              _createElementVNode("span", _hoisted_103, [
                                                _hoisted_104,
                                                _createElementVNode("ruby", null, [
                                                  _createVNode(_component_rb, null, {
                                                    default: _withCtx(() => [
                                                      _hoisted_105
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _hoisted_106,
                                                  _hoisted_107,
                                                  _hoisted_108
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["to"]),
                                    (!_unref(isSharedIdOrFixedIp))
                                      ? (_openBlock(), _createBlock(AppTooltip, {
                                          key: 0,
                                          enabled: !!_unref(bookShelfEntryErrorMessage),
                                          text: _unref(bookShelfEntryErrorMessage),
                                          location: "top"
                                        }, {
                                          default: _withCtx(({ listeners }) => [
                                            (!_unref(bookShelfEntryErrorMessage))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "actionButton animationLink",
                                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
                            bookCapsule.value &&
                              _unref(snackbarStore).handleAddBook(
                                bookCapsule.value.contentsId,
                                bookCapsule.value
                              )
                          ))
                                                }, [
                                                  _createVNode(AppButton, {
                                                    tag: "span",
                                                    rounded: "pill",
                                                    color: "add",
                                                    shadow: "m"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_109, [
                                                        _createElementVNode("span", _hoisted_110, [
                                                          _createVNode(AppImage, {
                                                            src: 
                                    require('@/assets/image/icon/icon_book_plus.svg')
                                  ,
                                                            alt: "",
                                                            width: "20",
                                                            height: "20"
                                                          }, null, 8, ["src"])
                                                        ]),
                                                        _hoisted_111
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : (_openBlock(), _createElementBlock("button", _mergeProps({ key: 1 }, _toHandlers(listeners), { class: "actionButton disabled" }), [
                                                  _createVNode(AppButton, {
                                                    tag: "span",
                                                    rounded: "pill",
                                                    color: "remove",
                                                    shadow: "none",
                                                    disabled: true
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_112, [
                                                        _createElementVNode("span", _hoisted_113, [
                                                          _createVNode(AppImage, {
                                                            src: 
                                    require('@/assets/image/icon/icon_book_plus_line.svg')
                                  ,
                                                            alt: "",
                                                            width: "20",
                                                            height: "20"
                                                          }, null, 8, ["src"])
                                                        ]),
                                                        _hoisted_114
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 16))
                                          ]),
                                          _: 1
                                        }, 8, ["enabled", "text"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("picture", null, [
                                    _createElementVNode("source", {
                                      srcset: 
                        require('@/assets/image/gacha/img_gacha_result_star.svg')
                      ,
                                      media: "(min-width: 1024px)"
                                    }, null, 8, _hoisted_117),
                                    _createElementVNode("source", {
                                      srcset: 
                        require('@/assets/image/gacha/img_gacha_result_star_h.svg')
                      
                                    }, null, 8, _hoisted_118),
                                    _createElementVNode("img", {
                                      src: 
                        require('@/assets/image/gacha/img_gacha_result_star.svg')
                      ,
                                      alt: ""
                                    }, null, 8, _hoisted_119)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("picture", null, [
                                    _createElementVNode("source", {
                                      srcset: 
                        require('@/assets/image/gacha/img_gacha_result_ball_l.svg')
                      ,
                                      media: "(min-width: 1024px)"
                                    }, null, 8, _hoisted_121),
                                    _createElementVNode("source", {
                                      srcset: 
                        require('@/assets/image/gacha/img_gacha_result_ball_l_h.svg')
                      
                                    }, null, 8, _hoisted_122),
                                    _createElementVNode("img", {
                                      src: 
                        require('@/assets/image/gacha/img_gacha_result_ball_l.svg')
                      ,
                                      alt: ""
                                    }, null, 8, _hoisted_123)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_124, [
                                  _createElementVNode("picture", null, [
                                    _createElementVNode("source", {
                                      srcset: 
                        require('@/assets/image/gacha/img_gacha_result_ball_r.svg')
                      ,
                                      media: "(min-width: 1024px)"
                                    }, null, 8, _hoisted_125),
                                    _createElementVNode("source", {
                                      srcset: 
                        require('@/assets/image/gacha/img_gacha_result_ball_r_h.svg')
                      
                                    }, null, 8, _hoisted_126),
                                    _createElementVNode("img", {
                                      src: 
                        require('@/assets/image/gacha/img_gacha_result_ball_r.svg')
                      ,
                                      alt: ""
                                    }, null, 8, _hoisted_127)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
          ])
        ])
      ]),
      _: 1
    }, 8, ["icon", "button"]),
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withCtx(() => [
        (errorMessages.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
              _createVNode(SlotDialog, {
                type: "error",
                messages: errorMessages.value,
                onClose: onCloseErrorDialog
              }, null, 8, ["messages"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})